import React, { useEffect, useRef, useState } from 'react'
import { motion } from "framer-motion"
import { Parallax, useParallax } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

export default function Home() {

    const [selectedYear, setSelectedYear] = useState("2014");
    const [lgShow, setLgShow] = useState(false);
    const [activePopup, setActivePopup] = useState(null);
    const [showFront, setShowFront] = useState(null);
    const [showDatabase, setShowDatabase] = useState(null);
    const [showTooltip, setShowTooltip] = useState(false);
    const [showDubai, setShowDubai] = useState(false);
    const [showUSA, setShowUSA] = useState(false);
    const [showAus, setShowAus] = useState(false);
    const [showbelgium, setShowBelgium] = useState(false);
    const [showLondon, setShowLondon] = useState(false);
    const [showWill, setShowWill] = useState(false);
    const [activeSlide, setActiveSlide] = useState(7);


    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const togglePopup = (index) => {
        setActivePopup(activePopup === index ? null : index);
    };

    const togglePopupFrontEnd = (index) => {
        setShowFront(showFront === index ? null : index);
    };

    const tooglePopupDatabase = (index) => {
        setShowDatabase(showDatabase === index ? null : index);
    };

    const technologies = [
        {
            name: 'Microsoft .NET',
            logoSrc: require('../assets/images/technologies/backend/b-1.webp'),
            link: '/software-development/dotnet',
            practice: '19 years',
            projects: '200+',
            workforce: '60+',
            description:
                'Our .NET developers can build sustainable and high-performing apps up to 2x faster due to outstanding .NET proficiency and high productivity.',
        },
        {
            name: 'Java',
            logoSrc: require('../assets/images/technologies/backend/b-2.webp'),
            link: '/software-development/java',
            practice: '25 years',
            projects: '110+',
            workforce: '40+',
            description:
                "Winklix's Java developers build secure, resilient and efficient cloud-native and cloud-only software of any complexity and successfully modernize legacy software solutions.",
        },
        {
            name: 'Python',
            logoSrc: require('../assets/images/technologies/backend/b-3.webp'),
            practice: '10 years',
            projects: '50+',
            workforce: '30',
            description:
                "Winklix's Python developers and data scientists excel at building general-purpose Python apps, big data and IoT platforms, AI and ML-based apps, and BI solutions.",
        },
        {
            name: 'Python',
            logoSrc: require('../assets/images/technologies/backend/b-4.webp'),
            practice: '10 years',
            projects: '50+',
            workforce: '30',
            description:
                "Winklix's Python developers and data scientists excel at building general-purpose Python apps, big data and IoT platforms, AI and ML-based apps, and BI solutions.",
        },
        {
            name: 'Python',
            logoSrc: require('../assets/images/technologies/backend/b-5.webp'),
            practice: '10 years',
            projects: '50+',
            workforce: '30',
            description:
                "Winklix's Python developers and data scientists excel at building general-purpose Python apps, big data and IoT platforms, AI and ML-based apps, and BI solutions.",
        },
        {
            name: 'Python',
            logoSrc: require('../assets/images/technologies/backend/b-6.webp'),
            practice: '10 years',
            projects: '50+',
            workforce: '30',
            description:
                "Winklix's Python developers and data scientists excel at building general-purpose Python apps, big data and IoT platforms, AI and ML-based apps, and BI solutions.",
        },
    ];

    const handlePagerClick = (index) => {
        setActiveSlide(index);
    };

    const handleTooltip = () => {
        setShowTooltip(!showTooltip);
    };

    const handleCloseTooltip = () => {
        setShowTooltip(false);
    };

    const handShowDubai = () => {
        setShowDubai(!showDubai);
    };

    const handCloseDubai = () => {
        setShowDubai(false);
    };

    const handleShowUSA = () => {
        setShowUSA(!showUSA);
    }

    const handleCloseUSA = () => {
        setShowUSA(false)
    }

    const handleShowAUS = () => {
        setShowAus(!showAus);
    }

    const handleCloseAUS = () => {
        setShowAus(false)
    }

    const handleShowBelguim = () => {
        setShowBelgium(!showbelgium);
    }

    const handleCloseBelgium = () => {
        setShowBelgium(false)
    }

    const handleShowLondon = () => {
        setShowLondon(!showLondon);
    }

    const handleCloseLondon = () => {
        setShowLondon(false)
    }

    const handleShowWill = () => {
        setShowWill(!showWill);
    }

    useEffect(() => {
        const script = document.createElement('script');
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            window.hbspt.forms.create({
                portalId: '7585485',
                formId: 'b472ef23-d7aa-4909-83a9-e8f71e0f26f9',
                target: '#hubspot-form-container',
            });
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);


    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>About Us</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta
                    name="description"
                    content="Equipped with in house ServiceNow experts , Winklix provides ServiceNow consulting and implementation services for your business to provide IT process visibility"
                />
                <meta
                    name="keywords"
                    content=""
                />
            </Helmet>

            <section className='about-section bottom'>
                <div className='container'>
                    <div className='row margin_top_about'>
                        <div className='col-lg-5'>
                            <div className='about-left'>
                                <h2 className='heading1 text-white'>About Winlkix</h2>
                                <div className='heading3 text-white'>IT Solution Simplified</div>
                                <p className='prose-md text-white'>Founded in 2014, Winklix is a US-based company specializing in IT consulting and software development services. Renowned for our unwavering commitment to budget and timeline adherence, transparent collaboration, and exceptional service quality, we are a trusted partner for clients worldwide.</p>
                            </div>
                        </div>
                        <div className='col-lg-7'>
                            <div className='about-slider'>
                                <Swiper
                                    breakpoints={{
                                        640: {
                                            slidesPerView: 1,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 1,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 1,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2000,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-blog-service-contribute"
                                >
                                    <SwiperSlide className="opportunities">
                                        <img src={require('../assets/images/team/team-2.webp')} alt='winklix about us' />
                                    </SwiperSlide>
                                    <SwiperSlide className="opportunities">
                                        <img src={require('../assets/images/team/team-3.webp')} alt='contact us winklix' />
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className='our-experience-section'>

                <div className="slide-krt bg_ex_1">
                    <div className="text-holder">
                        <div className="text-first ">
                            <div className='container'>
                                <div className="row top">
                                    <h2 className='heading1 text-center bottom'>Winklix in Numbers</h2>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="left_img_exp_1">
                                            <img src={require('../assets/images/number/number-1.webp')} alt='winklix about team' />
                                            <div className="exp-box">
                                                <span>10</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="right_content_part_1">
                                            <h3>Years in IT</h3>
                                            <p className="prose-lg top_exp">
                                                Over a decade of operation, Winklix has witnessed the ever-evolving technology landscape. This journey has taught us to remain adaptable and continually expand our expertise to anticipate and meet the demands of the future.
                                            </p><br />
                                            <div className='button-exp'>
                                                <a href="#Highlights" i>
                                                    <button>Winklix Highlights</button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="slide-krt bg_ex_2">
                    <div class="text-holder">
                        <div class="text">
                            <div className='container'>
                                <h2 className='heading1 text-center'>Winklix in Numbers</h2>
                                <div className='exp_previous bottom'>
                                    <h3><span>10</span> years in IT</h3>
                                </div>
                                <div className="row top">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="left_img_exp_2">
                                            <img src={require('../assets/images/number/number-2.webp')} alt='winklix contact' />
                                            <div className="exp-box box-bg-1">
                                                <span>216+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="right_content_part_2">
                                            <h3>IT professionals</h3>
                                            <p className="prose-lg top_exp">
                                                Winklix boasts a comprehensive team of IT professionals, including software engineers, IT consultants, data scientists, and AI specialists, enabling us to deliver end-to-end digital solutions of any complexity. With over 50% of our team comprising senior-level experts, we ensure top-tier expertise at every stage of your project.
                                            </p><br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="slide-krt bg_ex_3">
                    <div class="text-holder">
                        <div class="text">
                            <div className='container'>
                                <h2 className='heading1 text-center'>Winklix in Numbers</h2>
                                <div className='exp_previous bottom'>
                                    <h3><span>10+</span> years in IT</h3> &nbsp; &nbsp;<h3><span className="red-text-exp">216+</span> IT Professionals</h3>
                                </div>
                                <div className="row top">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="left_img_exp_3">
                                            <img src={require('../assets/images/number/number-3.webp')} alt='winklix contact' />
                                            <div className="exp-box">
                                                <span>2.1K</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="right_content_part_3">
                                            <h3>success stories</h3>
                                            <p className="prose-lg top_exp">
                                                Winklix has a deep understanding of the hidden challenges in IT outsourcing and excels in managing large-scale projects remotely. Based in Dallas, Texas, we partner with clients worldwide, spanning the United States, Gulf Cooperation Council, Europe, the United Kingdom, and Australia.
                                            </p><br />
                                            <div className='button-exp'>
                                                <Link to="https://www.winklix.com/case-study/">
                                                    <button>Our project portfolio</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="slide-krt bg_ex_1">
                    <div className="text-holder">
                        <div className="text-first ">
                            <div className='container'>
                                <div className="row top">
                                    <h2 className='heading1 text-center bottom'>Winklix in Numbers</h2>
                                    <div className='exp_previous bottom'>
                                        <h3><span>10+</span> years in IT</h3> &nbsp; &nbsp;<h3><span className="red-text-exp">216+</span> IT professionals</h3>&nbsp; &nbsp;&nbsp; <h3><span className="brown-text-exp">2.1K</span> success stories</h3>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="left_img_exp_1">
                                            <img src={require('../assets/images/number/number-4.webp')} alt='winklix about team' />
                                            <div className="exp-box">
                                                <span>21+</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="right_content_part_1">
                                            <h3>project managers</h3>
                                            <p className="prose-lg top_exp">
                                                Our project managers go beyond traditional administration. They strategically allocate project budgets, anticipate and mitigate risks, foster team cohesion, and maintain a proactive approach in every aspect to ensure the success of each project.
                                            </p><br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='our-experience-section-mobile'>
                <div className='exp_box_mobile bgcolor-1'>
                    <div className='container'>
                        <h2 className='heading1 text-center bottom'>Winklix in Numbers</h2>
                        <div className='exp-box-mobile_1'>10+</div>
                        <h3>years in IT</h3>
                        <p className='prose-md'>
                            Over a decade of operation, Winklix has witnessed the ever-evolving technology landscape. This journey has taught us to remain adaptable and continually expand our expertise to anticipate and meet the demands of the future.
                        </p>
                        <a href="#Highlights">
                            <button>Winklix Highlights</button>
                        </a><br />
                    </div>
                </div>
                <div className='exp_box_mobile bgcolor-2 top'>
                    <div className='container'>
                        <div className='exp-box-mobile_2'>216+</div>
                        <h3>IT Professionals</h3>
                        <p className='prose-md'> Winklix boasts a comprehensive team of IT professionals, including software engineers, IT consultants, data scientists, and AI specialists, enabling us to deliver end-to-end digital solutions of any complexity. With over 50% of our team comprising senior-level experts, we ensure top-tier expertise at every stage of your project. </p>
                    </div>
                </div>
                <div className='exp_box_mobile bgcolor-3 top'>
                    <div className='container'>
                        <div className='exp-box-mobile_3'>2.1K</div>
                        <h3>success stories</h3>
                        <p className='prose-md'>Winklix has a deep understanding of the hidden challenges in IT outsourcing and excels in managing large-scale projects remotely. Based in Dallas, Texas, we partner with clients worldwide, spanning the United States, Gulf Cooperation Council, Europe, the United Kingdom, and Australia.
                        </p>
                        <Link to="https://www.winklix.com/case-study/">
                            <button>Our project portfolio</button>
                        </Link>
                        <br />
                    </div>
                </div>
                <div className='exp_box_mobile bgcolor-4 top'>
                    <div className='container'>
                        <div className='exp-box-mobile_4'>21+</div>
                        <h3>Project managers</h3>
                        <p className='prose-md'>
                            Our project managers go beyond traditional administration. They strategically allocate project budgets, anticipate and mitigate risks, foster team cohesion, and maintain a proactive approach in every aspect to ensure the success of each project.
                        </p>
                    </div>
                </div>
            </div>

            <div className='client-section'>
                <div className='container'>
                    <h2 className='heading1'>Our Clients</h2>
                    <p className='prose-lg'>During our practice, we acquired expertise and a deep understanding of business models and processes across 30+ industries, including:</p>
                    <div className='row top'>
                        <Swiper
                            breakpoints={{
                                320: {
                                    slidesPerView: 2.4,
                                    spaceBetween: 10,
                                },
                                425: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 4,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 6,
                                    spaceBetween: 30,
                                },
                            }}
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="testimonialSwiper-client"
                        >

                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-1.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-2.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-3.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-4.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-5.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-6.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-7.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-8.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-9.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-10.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-11.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-12.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='client-image-slide'>
                                    <img src={require('../assets/images/client/client-13.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>

            <div className='timeline-map-section bottom'>
                <div className='container'>
                    <h2 className='heading1 text-center'>Our Presence</h2>
                    <p className='prose-lg text-center'>Based in the US with a global presence, our team leads digital transformation for businesses worldwide. We maintain on-site availability to deliver services to our key markets, including:</p>
                    <div className='row'>
                        <div className='col-lg-4'>
                            <div className='address_timeline_1 text-center'>
                                <h3>North America</h3>
                                <p className='prose-md'>Office Location: Delaware , New York <br />Number of clients: ~ 300+</p>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='address_timeline_2 text-center'>
                                <h3>Europe and the UK</h3>
                                <p className='prose-md'>Office locations: Belgium , London <br />
                                    Number of clients: ~160+</p>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='address_timeline_3 text-center'>
                                <h3>UAE</h3>
                                <p className='prose-md'>Office locations: Dubai , UAE <br />
                                    Number of clients: ~60+</p>
                            </div>
                        </div>
                    </div>

                    <div className="map-timeline">
                        <div className="head-quarter">
                            <p className='first' onClick={handleTooltip}><span> India</span>
                                {showTooltip && (
                                    <span className="tooltipsss">
                                        <div className='address-timeline'>
                                            <h3 className='text-left'>India</h3>
                                            <div className='address_timeline_add'>
                                                <div className='map_timeline_icons'><i class="fa fa-map-marker" aria-hidden="true"></i></div>
                                                <div className='map_timeline_content text-dark'><p className='prose-small'>Noida | Pune | Bengaluru |<br /> Mumbai</p></div>
                                            </div>
                                            <div className='social_mobile_address'>
                                                <p><i class="fa fa-phone" aria-hidden="true"></i><Link to="tel:+13477462125">+91 8882313131</Link></p>
                                                <p><i class="fa fa-envelope-o" aria-hidden="true"></i><Link to="mailto:sales@winklix.com">sales@winklix.com</Link></p>
                                            </div>
                                        </div>
                                        <i class="fa fa-times" aria-hidden="true" onClick={handleCloseTooltip}></i>
                                    </span>
                                )}
                            </p>
                            <p className='second'>
                                <p className='first' onClick={handShowDubai}><span> Dubai</span>
                                    {showDubai && (
                                        <span className="tooltipsss">
                                            <div className='address-timeline'>
                                                <h3 className='text-left'>United Arab Emirates</h3>
                                                <div className='address_timeline_add'>
                                                    <div className='map_timeline_icons'><i class="fa fa-map-marker" aria-hidden="true"></i></div>
                                                    <div className='map_timeline_content'><p className='prose-small'> World Trade Center, Sheikh Rashid - Tower <br />- Level- 24 Sheikh Zayed Rd - Trade Centre<br /> - Trade Centre 2 - Dubai - UAE</p></div>
                                                </div>
                                                <div className='social_mobile_address'>
                                                    <p><i class="fa fa-phone" aria-hidden="true"></i><Link to="tel:+13477462125">+1-(347) 746 2125</Link></p>
                                                    <p><i class="fa fa-envelope-o" aria-hidden="true"></i><Link to="mailto:sales@winklix.com">sales@winklix.com</Link></p>
                                                </div>
                                            </div>
                                            <i class="fa fa-times" aria-hidden="true" onClick={handCloseDubai}></i>
                                        </span>
                                    )}
                                </p>
                            </p>
                            <p className='third'>
                                <p className='first' onClick={handleShowUSA}><span> New&nbsp;York</span>
                                    {showUSA && (
                                        <span className="tooltipsss">
                                            <div className='address-timeline'>
                                                <h3 className='text-left'>New Yark USA</h3>
                                                <div className='address_timeline_add'>
                                                    <div className='map_timeline_icons'><i class="fa fa-map-marker" aria-hidden="true"></i></div>
                                                    <div className='map_timeline_content text-dark'><p className='prose-small'>175 Varick St, New York, NY<br /> 10014, United States</p></div>
                                                </div>
                                                <div className='social_mobile_address'>
                                                    <p><i class="fa fa-phone" aria-hidden="true"></i><Link to="tel:+13477462125">+1-(347) 746 2125</Link></p>
                                                    <p><i class="fa fa-envelope-o" aria-hidden="true"></i><Link to="mailto:sales@winklix.com">sales@winklix.com</Link></p>
                                                </div>
                                            </div>
                                            <i class="fa fa-times" aria-hidden="true" onClick={handCloseDubai}></i>
                                        </span>
                                    )}
                                </p>
                            </p>
                            <p className='five'>
                                <p className='first' onClick={handleShowAUS}><span> Australia</span>
                                    {showAus && (
                                        <span className="tooltipsss">
                                            <div className='address-timeline'>
                                                <h3 className='text-left'>Sydney, Australia</h3>
                                                {/* <p className='prose-md'><i class="fa fa-thumb-tack" aria-hidden="true"></i>Bhutani Techno Park Noida 127 </p> */}
                                            </div>
                                            <i class="fa fa-times" aria-hidden="true" onClick={handleCloseAUS}></i>
                                        </span>
                                    )}
                                </p>
                            </p>
                            <p className='six-map'>
                                <p className='first' onClick={handleShowBelguim}><span> Belgium</span>
                                    {showbelgium && (
                                        <span className="tooltipsss">
                                            <div className='address-timeline'>
                                                <h3 className='text-left'>Europe and the UK</h3>
                                                <div className='address_timeline_add'>
                                                    <div className='map_timeline_icons'><i class="fa fa-map-marker" aria-hidden="true"></i></div>
                                                    <div className='map_timeline_content text-dark'><p className='prose-small'>Levels 10 & 12, EU Quarter, 5-8 Schuman<br /> Roundabout 1040 Brussels, Belgium</p></div>
                                                </div>
                                                <div className='social_mobile_address'>
                                                    <p><i class="fa fa-phone" aria-hidden="true"></i><Link to="tel:+13477462125">+1-(347) 746 2125</Link></p>
                                                    <p><i class="fa fa-envelope-o" aria-hidden="true"></i><Link to="mailto:sales@winklix.com">sales@winklix.com</Link></p>
                                                </div>
                                            </div>
                                            <i class="fa fa-times" aria-hidden="true" onClick={handleCloseBelgium}></i>
                                        </span>
                                    )}
                                </p>
                            </p>
                            <p className='seven-map'>
                                <p className='first' onClick={handleShowLondon}><span>London</span>
                                    {showLondon && (
                                        <span className="tooltipsss">
                                            <div className='address-timeline'>
                                                <h3 className='text-left'>Europe and the UK</h3>
                                                <div className='address_timeline_add'>
                                                    <div className='map_timeline_icons'><i class="fa fa-map-marker" aria-hidden="true"></i></div>
                                                    <div className='map_timeline_content text-dark'><p className='prose-small'>Suite 319, 37 Cremer St, London<br /> E2 8HD, United Kingdom</p></div>
                                                </div>
                                                <div className='social_mobile_address'>
                                                    <p><i class="fa fa-phone" aria-hidden="true"></i><Link to="tel:+13477462125">+44 74183 43214</Link></p>
                                                    <p><i class="fa fa-envelope-o" aria-hidden="true"></i><Link to="mailto:sales@winklix.com">sales@winklix.com</Link></p>
                                                </div>
                                            </div>
                                            <i class="fa fa-times" aria-hidden="true" onClick={handleCloseLondon}></i>
                                        </span>
                                    )}
                                </p>
                            </p>
                            <p className='eight-map'>
                                <p className='first' onClick={handleShowWill}><span>Wilmington</span>
                                    {showWill && (
                                        <span className="tooltipsss">
                                            <div className='address-timeline'>
                                                <h3 className='text-left'>Wilmington USA</h3>
                                                <div className='address_timeline_add'>
                                                    <div className='map_timeline_icons'><i class="fa fa-map-marker" aria-hidden="true"></i></div>
                                                    <div className='map_timeline_content text-dark'><p className='prose-small'>919 North Market Street<br /> Sute 950 Wilmington De 19801</p></div>
                                                </div>
                                                <div className='social_mobile_address'>
                                                    <p><i class="fa fa-phone" aria-hidden="true"></i><Link to="tel:+13477462125">+1-(347) 746 2125</Link></p>
                                                    <p><i class="fa fa-envelope-o" aria-hidden="true"></i><Link to="mailto:sales@winklix.com">sales@winklix.com</Link></p>
                                                </div>
                                            </div>
                                            <i class="fa fa-times" aria-hidden="true" onClick={handleCloseLondon}></i>
                                        </span>
                                    )}
                                </p>
                            </p>
                        </div>
                        <img src={require('../assets/images/world-map.webp')} className='bottom' alt='' />
                    </div>

                </div>
            </div>

            <div className="pimcore_area_timeline pimcore_area_content" id="Highlights">
                <section className="tl-wrapper" data-track-source="Editable: Timeline">
                    <div>
                        <h2 className="tl-title">
                            <span id="history" className="not-hover-link" name="history">
                                Winklix's Highlights
                            </span>
                        </h2>
                        <div className="tl-slider">
                            <div className="tl-slider-wrap bg-white">
                                <div className={`tl-slider-item ${activeSlide === 1 ? 'active' : ''}`} data-slide="1">
                                    <div className="tl-slider-description-inner">
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={410}
                                                    height={252}
                                                    alt="2014"
                                                    title="2014"
                                                    src={require('../assets/images/Logo_active.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>
                                                    Winklix has started as an IT company in 2014 in Delaware , US offering custom software solutions.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`tl-slider-item ${activeSlide === 2 ? 'active' : ''}`} data-slide="2">
                                    <div className="tl-slider-description-inner">
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-description">
                                                <p>
                                                    Winklix has experiencing remarkable growth, with its employee base in the United States expanding at an impressive average rate of 50% per year. Additionally, the company has strengthened its international presence by opening offices in Noida, India.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`tl-slider-item ${activeSlide === 3 ? 'active' : ''}`} data-slide="3">
                                    <div className="tl-slider-description-inner">
                                        <div className="tl-slider-description-item">

                                            <div className="tl-slider-description">
                                                <p>Winklix has achieved significant milestones, growing its team to over 60 developers, sales professionals,
                                                    and administrative staff by the end of the year. Additionally, the South Florida Business Journal recognized Winklix as one of South Florida's fastest-growing companies, boasting an impressive 309% gross revenue growth.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`tl-slider-item ${activeSlide === 4 ? 'active' : ''}`} data-slide="4">
                                    <div className="tl-slider-description-inner">
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={383}
                                                    height={130}
                                                    alt="Salesforce Partnership"
                                                    title="Salesforce Partnership"
                                                    src={require('../assets/images/partner/sales-1.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix joined <strong>Salesforce Base Level Partnership</strong></p>
                                            </div>
                                        </div>
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={289}
                                                    height={172}
                                                    alt="Mirosoft"
                                                    title="Mirosoft"
                                                    src={require('../assets/images/partner/partner-1.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix joined <strong>Microsoft Partner Network.</strong></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`tl-slider-item ${activeSlide === 5 ? 'active' : ''}`} data-slide="5">
                                    <div className="tl-slider-description-inner">
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={141}
                                                    height={100}
                                                    alt="ServiceNow Partner"
                                                    title="ServiceNow Partner"
                                                    src={require('../assets/images/partner/sap-part.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix joined <strong>SAP</strong> joined .</p>
                                            </div>
                                        </div>
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={141}
                                                    height={100}
                                                    alt="ServiceNow"
                                                    title="ServiceNow"
                                                    src={require('../assets/images/partner/servicenow-part.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix partnered with <strong>ServiceNow</strong>.</p>
                                            </div>
                                        </div>
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={141}
                                                    height={100}
                                                    alt="United Kingdom"
                                                    title="United Kingdom"
                                                    src={require('../assets/images/partner/uk.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix expands to new, branch in London , to accommodate rapid growth</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`tl-slider-item ${activeSlide === 6 ? 'active' : ''}`} data-slide="6">
                                    <div className="tl-slider-description-inner">
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={141}
                                                    height={100}
                                                    alt="finencial partner"
                                                    title="finencial partner"
                                                    src={require('../assets/images/partner/finencial.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>The Financial Times named Winklix USA Corporation among Americas’ Fastest Growing Companies 2023.</p>
                                            </div>
                                        </div>
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={141}
                                                    height={100}
                                                    alt="Winklix"
                                                    title="Winklix"
                                                    src={require('../assets/images/Logo_active.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix has crossed 200+ workforce catering clients like Boeing , Walmart</p>
                                            </div>
                                        </div>
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={141}
                                                    height={100}
                                                    alt="Global"
                                                    title="Global"
                                                    src={require('../assets/images/partner/global.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix lands a spot on the exclusive Clutch 1000 List 2023</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`tl-slider-item ${activeSlide === 7 ? 'active' : ''}`} data-slide="7">
                                    <div className="tl-slider-description-inner">
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={141}
                                                    height={100}
                                                    alt="Winklix partner"
                                                    title="Winklix partner"
                                                    src={require('../assets/images/partner/tags.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix receives Transatlantic Growth award for European expansion efforts.</p>
                                            </div>
                                        </div>
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={1012}
                                                    height={300}
                                                    alt="Winklix partner"
                                                    title="Winklix partner"
                                                    src={require('../assets/images/partner/tops.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix recognized as one of the Top 50+ Software Development Companies in the USA by TechReviewer.</p>
                                            </div>
                                        </div>
                                        <div className="tl-slider-description-item">
                                            <div className="tl-slider-photo">
                                                <img
                                                    width={141}
                                                    height={100}
                                                    alt="Winklix"
                                                    title="Winklix"
                                                    src={require('../assets/images/partner/10-years.webp')}
                                                    className="lazy entered loaded"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="tl-slider-description">
                                                <p>Winklix celebrates 10 years of delivering world-class software solutions.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="tl-pager">
                                <div className="tl-pager-inner">
                                    <div
                                        className={`tl-pager-item item_1 ${activeSlide === 1 ? 'active' : ''}`}
                                        onClick={() => handlePagerClick(1)}
                                    >
                                        2014
                                    </div>
                                    <div
                                        className={`tl-pager-item item_2 ${activeSlide === 2 ? 'active' : ''}`}
                                        onClick={() => handlePagerClick(2)}

                                    >
                                        2015 <div class="tl-divider"></div>2016
                                    </div>
                                    <div
                                        className={`tl-pager-item item_3 ${activeSlide === 3 ? 'active' : ''}`}
                                        onClick={() => handlePagerClick(3)}

                                    >
                                        2017
                                    </div>
                                    <div
                                        className={`tl-pager-item item_4 ${activeSlide === 4 ? 'active' : ''}`}
                                        onClick={() => handlePagerClick(4)}

                                    >
                                        2018 <div class="tl-divider"></div> 2020
                                    </div>
                                    <div
                                        className={`tl-pager-item item_5 ${activeSlide === 5 ? 'active' : ''}`}
                                        onClick={() => handlePagerClick(5)}

                                    >
                                        2021 <div class="tl-divider"></div> 2022
                                    </div>

                                    <div
                                        className={`tl-pager-item item_6 ${activeSlide === 6 ? 'active' : ''}`}
                                        onClick={() => handlePagerClick(6)}

                                    >
                                        2023
                                    </div>
                                    <div
                                        className={`tl-pager-item item_7 ${activeSlide === 7 ? 'active' : ''}`}
                                        onClick={() => handlePagerClick(7)}

                                    >
                                        2024
                                    </div>
                                    <div className="tl-pager-item-last item_8">
                                        Let's build the future together
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className='industry-serve-section'>
                <div className='container'>
                    <h2 className='heading1'>Industries Winklix Serves</h2>
                    <p className='prose-lg'>During our practice, we acquired expertise and a deep understanding of business models and processes across 30+ industries, including:</p>
                    <div class="row top">
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/1.webp')} alt='' />
                                    <h3 class="mt-0">Healthcare</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/2.webp')} alt='' />
                                    <h3 class="mt-0">Banking</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/3.webp')} alt='' />
                                    <h3 class="mt-0">Insurance</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/4.webp')} alt='' />
                                    <h3 class="mt-0">Lending</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/5.webp')} alt='' />
                                    <h3 class="mt-0">Investment</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/6.webp')} alt='' />
                                    <h3 class="mt-0">Retail</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/7.webp')} alt='' />
                                    <h3 class="mt-0">Manufacturing</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/8.webp')} alt='' />
                                    <h3 class="mt-0">Professional services</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>

                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/9.webp')} alt='' />
                                    <h3 class="mt-0">Oil and Gas</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/10.webp')} alt='' />
                                    <h3 class="mt-0">Telecoms</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/11.webp')} alt='' />
                                    <h3 class="mt-0">Logistics and Transportation</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/industries-serve/12.webp')} alt='' />
                                    <h3 class="mt-0">Engineering and Construction</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='client-says top'>
                <div className='container'>
                    <h2 className='heading1 text-center text-white'>What Our Clients Say</h2>
                    <div className='row top'>
                        <Swiper
                            breakpoints={{
                                640: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 1,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 2,
                                    spaceBetween: 30,
                                },
                                1440: {
                                    slidesPerView: 3,
                                    spaceBetween: 30,
                                },
                            }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="testimonialSwiper-client"
                        >
                            <SwiperSlide className="col-lg-4 ">
                                {/* <div className='client-say-item'> */}
                                <iframe
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                    class="lazy entered loaded"
                                    data-src="https://www.youtube.com/embed/vyFlrXqWKc8"
                                    frameborder="0"
                                    height="450"
                                    scrolling="no"
                                    width="100%"
                                    src="https://www.youtube.com/embed/vyFlrXqWKc8"
                                    title="video intro"
                                ></iframe>

                                {/* <div className='item-rate'>
                                        <img src="https://www.scnsoft.com/testimonials-logos/bioaffinity-technologies-logo.svg" alt='' />
                                        <div className='rate'>
                                            <i class="fa fa-star" aria-hidden="true"></i>
                                            <i class="fa fa-star" aria-hidden="true"></i>
                                            <i class="fa fa-star" aria-hidden="true"></i>
                                            <i class="fa fa-star" aria-hidden="true"></i>
                                            <i class="fa fa-star" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                    <p className='prose-lg mt-3'><a href='#'><strong>Delap LLP</strong></a> A Finencial Services Firm</p>
                                    <div className='client-user'>
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/manish.webp" alt='' />
                                        <p className='prose-lg'><i class="fa fa-quote-left" aria-hidden="true"></i> Winklix has been vital to our company’s growth in ecommerce over the last 3 years. We rely on the team for a variety of Magento support tasks, and they always deal with our problems fast.</p>
                                    </div>
                                    <div className='user-desig'>
                                        <p><strong>Manish Yadav</strong><br />Creative Director</p>
                                    </div>
                                    <hr />
                                    <div className='link-bottom'>
                                        <a href='#' aria-label="show orginal" onClick={() => setLgShow(true)}>Read the Original</a> |
                                        <a href='#' aria-label="check out project">Check the Project</a> |
                                        <a href='#' aria-label="share profile"><i class="fa fa-share-alt" aria-hidden="true"></i></a>
                                    </div> */}
                                {/* </div> */}
                            </SwiperSlide>
                            <SwiperSlide className="col-lg-4 ">
                                <iframe
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                    class="lazy entered loaded"
                                    data-src="https://www.youtube.com/embed/7_OhPkg9Wx4"
                                    frameborder="0"
                                    height="450"
                                    scrolling="no"
                                    width="100%"
                                    src="https://www.youtube.com/embed/7_OhPkg9Wx4"
                                    title="video intro"
                                ></iframe>
                            </SwiperSlide>

                            <SwiperSlide className="col-lg-4 ">
                                <iframe
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen
                                    class="lazy entered loaded"
                                    data-src="https://www.youtube.com/embed/Gk_NjLmT1wM"
                                    frameborder="0"
                                    height="450"
                                    scrolling="no"
                                    width="100%"
                                    src="https://www.youtube.com/embed/Gk_NjLmT1wM"
                                    title="video intro"
                                ></iframe>

                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>


            <div className='success-project top bottom'>
                <div className='container'>
                    <h2 className='heading1'>What We Do to Guarantee Project Success</h2>
                    <p className='prose-lg'>At Winklix, we are committed to driving project success, no matter the challenges. These are not just lofty claims — we employ a range of practices and techniques to keep projects on track and fulfill our commitments, regardless of any obstacles that may arise.</p>
                    <div className='row mt-4'>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-1.webp')} alt='' />
                                <h3>Proactive Requirements Engineering</h3>
                                <p className='prose-md'>We don’t expect clients to always provide a detailed project specification. When only high-level requirements are shared, we delve deeper, ask insightful questions, and uncover hidden needs and objectives.</p>
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-2.webp')} alt='' />
                                <h3>Precise and Practical Cost Estimation</h3>
                                <p className='prose-md'>Through comprehensive work during the discovery phase, we gain a clear understanding of the full project scope, allowing us to provide an accurate cost estimate. We consider potential risks and actively seek opportunities for cost optimization wherever possible.</p>
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-3.webp')} alt='' />
                                <h3>Flexible, Yet Manageable, Project Scoping</h3>
                                <p className='prose-md'>We define detailed project requirements at the outset and remain adaptable to stakeholder feedback throughout the process. This ensures the final software aligns with the client’s evolving goals, even as they change over time.</p>
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-4.webp')} alt='' />
                                <h3>Team Selection Based on Expertise</h3>
                                <p className='prose-md'>We evaluate the expertise required for the project and handpick team members with the right skill set. This ensures our clients receive the most cost-effective resource allocation.</p><br />
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-5.webp')} alt='' />
                                <h3>Thorough Risk Management</h3>
                                <p className='prose-md'>We assess operational, business, technological, and external risks, developing mitigation strategies to respond swiftly and confidently to any potential disruptions.</p>
                                <br />
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-6.webp')} alt='' />
                                <h3>Flexible and Iterative Delivery</h3>
                                <p className='prose-md'>We manage changing requirements efficiently by breaking the software development process into sprints. Each sprint prioritizes features from the backlog, followed by a complete cycle of ideation, development, testing, and deployment.</p>
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-7.webp')} alt='' />
                                <h3>Scope Creep Prevention</h3>
                                <p className='prose-md'>We remain flexible to adjust both functional and non-functional requirements throughout the project. To maintain control, we carefully assess the feasibility and impact of each change request.</p>
                                <br />
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-8.webp')} alt='' />
                                <h3>Budget control</h3>
                                <p className='prose-md'>We provide realistic cost estimation backed up by the risk mitigation plan, manage change requests thoroughly, and monitor the budget spending throughout the project.   </p>
                                <br />
                                <button>Details<i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-9.webp')} alt='' />
                                <h3>Accountable Deadline Management</h3>
                                <p className='prose-md'>We effectively manage project timelines through work decomposition, well-defined documentation, and regular retrospectives.</p>
                                <br /><br />
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-10.webp')} alt='' />
                                <h3>Effective Team Coordination</h3>
                                <p className='prose-md'>We select the most suitable communication methods and frequencies, creating tailored communication flows to ensure seamless collaboration between all project stakeholders, both on our side and the client's.</p>
                                <br /><button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-11.webp')} alt='' />
                                <h3>Regular Progress Reporting</h3>
                                <p className='prose-md'>We provide consistent updates on agreed KPIs and offer progress forecasts to ensure clients are always informed and aligned.</p><br /><br />
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='suceess-project-item'>
                                <img src={require('../assets/images/project/p-12.webp')} alt='' />
                                <h3>Unified Knowledge Management</h3>
                                <p className='prose-md'>We centralize project knowledge, ensuring that all stakeholders have access to up-to-date information and insights, promoting better decision-making and collaboration.</p><br />
                                <button>Learn More <i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="building-trust">
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='truested-video'>
                                <div className="pimcore_area_wysiwyg pimcore_area_content">
                                    <div data-track-source="Editable: Wysiwyg">
                                        <section className="a-wysiwyg prose prose-lg">
                                            <p>
                                                <iframe
                                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                    allowfullscreen
                                                    frameborder="0"
                                                    height="300"
                                                    scrolling="no"
                                                    width="100%"
                                                    src="https://www.youtube.com/embed/gW5mqyFnPAY"
                                                    title="video intro"
                                                ></iframe>
                                            </p>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='truested-content'>
                                <h3>Building Trust with Transparency</h3>
                                <p className='prose-lg'>Outsourcing to another company, no matter how reputable, always carries some risk. As a vendor, the best way we can mitigate that risk is by being fully transparent about who we are, what we do, and where we’ve achieved success. At Winklix, we focus on facts, not promises — this is our first step in building trust.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pimcore_area_service-map pimcore_area_content">
                <section className="sm-wrapper full-height" data-track-source="Editable: Service Map">
                    <div className="container">
                        <div className="sm-items">
                            <div className="sm-item sm-item-main">
                                <div className="sm-item-container">
                                    <div className="sm-item-content">
                                        <h2 className="sm-item-title">Our Service Map</h2>
                                    </div>
                                </div>
                            </div>

                            <Link to="/about#" target="_self" className="sm-item has-link js-track-click" data-track-element="card">
                                <div className="sm-item-container">
                                    <div className="sm-item-bg lazy entered loaded service_first"></div>
                                    <div className="sm-item-content">
                                        <div className="sm-item-title">
                                            <p>IT consulting</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="/about#" target="_self" className="sm-item has-link js-track-click" data-track-element="card">
                                <div className="sm-item-container">
                                    <div className="sm-item-bg lazy entered loaded service_second"></div>
                                    <div className="sm-item-content">
                                        <div className="sm-item-title">
                                            <p>Software development</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="/about#" target="_self" className="sm-item has-link js-track-click" data-track-element="card">
                                <div className="sm-item-container">
                                    <div className="sm-item-bg lazy entered loaded service_third"></div>
                                    <div className="sm-item-content">
                                        <div className="sm-item-title">
                                            <p>Testing and QA</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="/about#" target="_self" className="sm-item has-link js-track-click" data-track-element="card">
                                <div className="sm-item-container">
                                    <div className="sm-item-bg lazy entered loaded service_forth"></div>
                                    <div className="sm-item-content">
                                        <div className="sm-item-title">
                                            <p>Help desk services</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="/about#" target="_self" className="sm-item has-link js-track-click" data-track-element="card">
                                <div className="sm-item-container">
                                    <div className="sm-item-bg lazy entered loaded service_five"></div>
                                    <div className="sm-item-content">
                                        <div className="sm-item-title">
                                            <p>Data analytics</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="/about#" target="_self" className="sm-item has-link js-track-click" data-track-element="card">
                                <div className="sm-item-container">
                                    <div className="sm-item-bg lazy entered loaded service_six"></div>
                                    <div className="sm-item-content">
                                        <div className="sm-item-title">
                                            <p>Cybersecurity services</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            <Link to="/about#" target="_self" className="sm-item has-link js-track-click" data-track-element="card">
                                <div className="sm-item-container">
                                    <div className="sm-item-bg lazy entered loaded service_seven"></div>
                                    <div className="sm-item-content">
                                        <div className="sm-item-title">
                                            <p>Infrastructure services</p>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>

            <div className='industry-serve-section'>
                <div className='container'>
                    <h2 className='heading1'>Solutions We Cover</h2>
                    <p className='prose-lg'>With over 14 years in Information Technology, we have built up expertise in dozens of domains, including:</p>
                    <div class="row top">
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Enterprise applications</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">ERP</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">CRM</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Operations management</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Corporate finance</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Payments</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Asset management</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Document management</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>

                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Intranets</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">HR management</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">eLearning</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">eCommerce</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>

                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Supply chain management</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Fleet management</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Data analytics</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <h3 class="mt-0">Web portals</h3>
                                    <i class="fa fa-long-arrow-right arrow-icons" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pimcore_area_technologies pimcore_area_content ">
                <div className="t-wrapper editable-wrapper container">
                    <div className="t-content">
                        <h2 className='heading1'>Our Capabilities and Technological Expertise</h2>
                        <div className="t-items-wrapper lazy entered loaded bg_lng">
                            <div className="t-items-container">
                                <div className="pimcore_area_technologies pimcore_area_content">

                                    <div className="t-items">
                                        <div className="t-item">
                                            <p className="t-item-title">Back-end programming languages</p>
                                            <div className="t-item-groups">
                                                <div className="t-item-group">
                                                    <div className="t-item-group-technologies">
                                                        {technologies.map((tech, index) => (
                                                            <div key={index} className="t-item-group-technology">
                                                                <p

                                                                    target="_self"
                                                                    className="t-item-group-technology-content"
                                                                    aria-label={tech.name}
                                                                    onClick={() => togglePopup(index)}
                                                                >
                                                                    <img
                                                                        src={tech.logoSrc}
                                                                        width="152"
                                                                        height="145"
                                                                        alt={tech.name}
                                                                    />
                                                                </p>

                                                                {activePopup === index && (
                                                                    <div className="t-popup active mx_wdth">
                                                                        <div className="t-popup-columns">
                                                                            <div className="t-popup-column">
                                                                                <p className="t-popup-column-title">Practice</p>
                                                                                <p className="t-popup-column-value t-practice">{tech.practice}</p>
                                                                            </div>

                                                                            <div className="t-popup-column-separator"></div>

                                                                            <div className="t-popup-column">
                                                                                <p className="t-popup-column-title">Projects</p>
                                                                                <p className="t-popup-column-value t-projects">{tech.projects}</p>
                                                                            </div>

                                                                            <div className="t-popup-column-separator"></div>

                                                                            <div className="t-popup-column">
                                                                                <p className="t-popup-column-title">Workforce</p>
                                                                                <p className="t-popup-column-value t-workforce">{tech.workforce}</p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="t-popup-description">
                                                                            <p>{tech.description}</p>
                                                                        </div>

                                                                        <a
                                                                            href={tech.link}
                                                                            target="_self"
                                                                            className="t-popup-link js-track-click"
                                                                        >
                                                                            Find out more <i class="fa fa-arrow-right" aria-hidden="true"></i>
                                                                        </a>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="t-items mt-4">
                                        <div className="t-item">
                                            <p className="t-item-title">Front-end programming languages</p>
                                            <div className="t-item-groups">
                                                <div className="t-item-group">
                                                    <p>LANGUAGES</p>
                                                    <div className="t-item-group-technologies">
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/front/f-1.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/front/f-2.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(0)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/front/f-3.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="t-item-group">
                                                    <p>JAVASCRIPT FRAMEWORKS</p>
                                                    <div className="t-item-group-technologies">
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/front/f-4.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/front/f-5.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(1)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/front/f-6.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(2)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/front/f-7.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(3)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/front/f-8.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(4)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/front/f-9.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="t-items mt-4">
                                        <div className="t-item">
                                            <p className="t-item-title">Mobile</p>
                                            <div className="t-item-groups">
                                                <div className="t-item-group">
                                                    <div className="t-item-group-technologies">
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(5)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/mobile/m-1.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(6)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/mobile/m-2.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(7)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/mobile/m-3.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(8)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/mobile/m-4.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(9)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/mobile/m-5.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(10)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/mobile/m-6.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(11)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/mobile/m-7.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(12)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/mobile/m-8.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="t-items mt-4">
                                        <div className="t-item">
                                            <p className="t-item-title">Databases / data storages</p>
                                            <div className="t-item-groups">
                                                <div className="t-item-group">
                                                    <p>SQL</p>
                                                    <div className="t-item-group-technologies">

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(0)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-1.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-2.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(1)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-3.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(2)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-4.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(3)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-5.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(4)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-6.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="t-item-group">
                                                    <p>NOSQL</p>
                                                    <div className="t-item-group-technologies">

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(5)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-7.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(6)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-8.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 6 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-columns">
                                                                        <div className="t-popup-column">
                                                                            <p className="t-popup-column-title">Practice</p>
                                                                            <p className="t-popup-column-value t-practice">19 years</p>
                                                                        </div>

                                                                        <div className="t-popup-column-separator"></div>

                                                                        <div className="t-popup-column">
                                                                            <p className="t-popup-column-title">Projects</p>
                                                                            <p className="t-popup-column-value t-projects">200+</p>
                                                                        </div>

                                                                        <div className="t-popup-column-separator"></div>

                                                                        <div className="t-popup-column">
                                                                            <p className="t-popup-column-title">Workforce</p>
                                                                            <p className="t-popup-column-value t-workforce">60+</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            Our .NET developers can build sustainable and high-performing apps up to 2x faster due to outstanding .NET proficiency and high productivity.
                                                                        </p>
                                                                    </div>

                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(7)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-9.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 7 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            Our .NET developers can build sustainable and high-performing apps up to 2x faster due to outstanding .NET proficiency and high productivity.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(8)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-10.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 8 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            Our .NET developers can build sustainable and high-performing apps up to 2x faster due to outstanding .NET proficiency and high productivity.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(9)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-11.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 9 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            Our .NET developers can build sustainable and high-performing apps up to 2x faster due to outstanding .NET proficiency and high productivity.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-2.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="t-items mt-4">
                                        <div className="t-item">
                                            <p className="t-item-title">Cloud databases, warehouses, and storage</p>
                                            <div className="t-item-groups">
                                                <div className="t-item-group">
                                                    <p>AWS</p>
                                                    <div className="t-item-group-technologies">

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-1.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(10)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-2.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 10 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We use Amazon Redshift to build cost-effective data warehouses that easily handle complex queries and large amounts of data.
                                                                        </p>
                                                                        <a
                                                                            href="/software-development/dotnet"
                                                                            target="_self"
                                                                            className="t-popup-link js-track-click"
                                                                        >
                                                                            Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(11)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-3.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 11 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We use Amazon Redshift to build cost-effective data warehouses that easily handle complex queries and large amounts of data.
                                                                        </p>
                                                                        <a
                                                                            href="/software-development/dotnet"
                                                                            target="_self"
                                                                            className="t-popup-link js-track-click"
                                                                        >
                                                                            Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(12)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-4.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 12 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We use Amazon DynamoDB as a NoSQL database service for solutions that require low latency, high scalability and always available data.
                                                                        </p>
                                                                        <a
                                                                            href="/software-development/dotnet"
                                                                            target="_self"
                                                                            className="t-popup-link js-track-click"
                                                                        >
                                                                            Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-5.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-6.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="t-item-group">
                                                    <p>Google Cloud Platform</p>
                                                    <div className="t-item-group-technologies">

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-14.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(14)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-15.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 14 && (
                                                                <div className="t-popup active mx_wdth">

                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            Our .NET developers can build sustainable and high-performing apps up to 2x faster due to outstanding .NET proficiency and high productivity.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="t-item-group">
                                                    <p>AZURE</p>
                                                    <div className="t-item-group-technologies">

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-7.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-8.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>


                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(15)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-9.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 15 && (
                                                                <div className="t-popup active mx_wdth">

                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We leverage Azure Cosmos DB to implement a multi-model, globally distributed, elastic NoSQL database on the cloud. Our team used Cosmos DB in a connected car solution for one of the world’s technology leaders.                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => tooglePopupDatabase(16)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-10.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showDatabase === 16 && (
                                                                <div className="t-popup active mx_wdth">

                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            Azure SQL Database is great for handling large volumes of data and varying database traffic: it easily scales up and down without any downtime or disruption to the applications. It also offers automatic backups and point-in-time recoveries to protect databases from accidental corruption or deletion.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-11.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-12.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/cloud/cloud-13.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="t-item-group">
                                                    <p>OTHER</p>
                                                    <div className="t-item-group-technologies">

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/database/data-2.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="t-items mt-4">
                                        <div className="t-item">
                                            <p className="t-item-title">Big Data</p>
                                            <div className="t-item-groups">
                                                <div className="t-item-group">
                                                    <div className="t-item-group-technologies">
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(17)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-1.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 17 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            By request of a leading market research company, we have built a Hadoop-based big data solution for monitoring and analyzing advertising channels in 10+ countries.                                                                        </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(18)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-2.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 18 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            A large US-based jewelry manufacturer and retailer relies on ETL pipelines built by Winklix’s Spark developers.
                                                                        </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(20)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-4.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 20 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We use Kafka for handling big data streams. In our IoT pet tracking solution, Kafka processes 30,000+ events per second from 1 million devices.
                                                                        </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(21)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-5.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 21 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            Winklix has helped one of the top market research companies migrate its big data solution for advertising channel analysis to Apache Hive. Together with other improvements, this led to 100x faster data processing.
                                                                        </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(22)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-6.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 22 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            Winklix has helped one of the top market research companies migrate its big data solution for advertising channel analysis to Apache Hive. Together with other improvements, this led to 100x faster data processing.
                                                                        </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(23)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-7.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 23 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We use HBase if your database should scale to billions of rows and millions of columns while maintaining constant write and read performance.
                                                                        </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(24)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-8.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 24 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We leverage Azure Cosmos DB to implement a multi-model, globally distributed, elastic NoSQL database on the cloud. Our team used Cosmos DB in a connected car solution for one of the world’s technology leaders.
                                                                        </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(25)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-9.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 25 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We use Amazon Redshift to build cost-effective data warehouses that easily handle complex queries and large amounts of data.                                                                        </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(26)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-10.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 26 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We use Amazon DynamoDB as a NoSQL database service for solutions that require low latency, high scalability and always available data.                                                                        </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(27)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-11.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 27 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            Winklix used MongoDB-based warehouse for an IoT solution that processed 30K+ events/per second from 1M devices. We’ve also delivered MongoDB-based operations management software for a pharma manufacturer.                                                                      </p>
                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="JavaScript"
                                                                onClick={() => togglePopupFrontEnd(28)}

                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/big-data/big-12.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="JavaScript"
                                                                />
                                                            </Link>

                                                            {showFront === 28 && (
                                                                <div className="t-popup active mx_wdth">
                                                                    <div className="t-popup-description">
                                                                        <p>
                                                                            We use Google Cloud Datastore to set up a highly scalable and cost-effective solution for storing and managing NoSQL data structures. This database can be easily integrated with other Google Cloud services (BigQuery, Kubernetes, and many more).</p>                                                                    </div>
                                                                    <a
                                                                        href="/software-development/dotnet"
                                                                        target="_self"
                                                                        className="t-popup-link js-track-click"
                                                                    >
                                                                        Find out more <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="t-items mt-4">
                                        <div className="t-item">
                                            <p className="t-item-title">DevOps</p>
                                            <div className="t-item-groups">
                                                <div className="t-item-group">
                                                    <p>CONTAINERIZATION</p>
                                                    <div className="t-item-group-technologies">
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-1.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-2.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-3.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-4.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="t-item-group">
                                                    <p>AUTOMATION</p>
                                                    <div className="t-item-group-technologies">
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-5.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-6.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-7.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-8.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-9.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="CSS"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/devops/dev-10.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="CSS"
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="t-items mt-4">
                                        <div className="t-item">
                                            <p className="t-item-title">DevOps</p>
                                            <div className="t-item-groups">
                                                <div className="t-item-group">
                                                    <p>CI/CD TOOLS</p>
                                                    <div className="t-item-group-technologies">
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-1.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-2.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-3.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-4.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-5.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="t-item-group">
                                                    <p>MONITORING</p>
                                                    <div className="t-item-group-technologies">
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-7.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-8.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-9.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-10.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="t-item-group-technology">
                                                            <Link
                                                                to='/about'
                                                                target="_self"
                                                                className="t-item-group-technology-content has-popup js-track-click"
                                                                aria-label="HTML"
                                                            >
                                                                <img
                                                                    src={require('../assets/images/technologies/tools/tool-11.webp')}
                                                                    width="152"
                                                                    height="145"
                                                                    alt="HTML"
                                                                />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="t-items-shadow active"></div>
                        </div>
                        <p className='prose-lg mt-4'>Winklix has been recognized as a 4-Year Champion in the Financial Times' The Americas’ Fastest-Growing Companies ranking. With a partner network comprising five companies and over 216+ employees, our strong technological expertise enables us to effectively meet the software engineering and infrastructure management needs of midsized and large organizations.</p>
                    </div>
                </div>
            </div>

            <div className='client-section'>
                <div className='container'>
                    <h2 className='heading1'>Our Technology Partnerships</h2>
                    <p className='prose-lg'>Throughout our history, we have developed a number of partnerships with technology leaders, who highly attested our technical competencies and the ability to understand our clients’ needs and translate them into quality services:</p>
                    <div className='row top'>
                        <Swiper
                            breakpoints={{
                                320: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                640: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                768: {
                                    slidesPerView: 4,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 6,
                                    spaceBetween: 30,
                                },
                            }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="testimonialSwiper-client"
                        >

                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/partner-1.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/partner-2.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/partner-3.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/partner-5.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/sales-1.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/sales-2.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/sales-3.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className="col-md-4 col-4">
                                <div className='client-image-slide-partnerships'>
                                    <img src={require('../assets/images/partner/sales-4.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>

            <div className='industry-serve-section'>
                <div className='container'>
                    <h2 className='heading1 text-dark mb-4'>We eagerly put in use IT innovations</h2>
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/innovations/1.webp')} alt='' />
                                    <h3 class="mt-0">Big Data</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/innovations/2.webp')} alt='' />
                                    <h3 class="mt-0">Artificial Intelligence</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/innovations/3.webp')} alt='' />
                                    <h3 class="mt-0">Data Science</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/innovations/4.webp')} alt='' />
                                    <h3 class="mt-0">Internet of Things</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/innovations/5.webp')} alt='' />
                                    <h3 class="mt-0">Computer Vision</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/innovations/6.webp')} alt='' />
                                    <h3 class="mt-0">Augmented Reality</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/innovations/7.webp')} alt='' />
                                    <h3 class="mt-0">Virtual Reality</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="software-develop salesf-box height-100">
                                <Link to="/about#">
                                    <img src={require('../assets/images/innovations/8.webp')} alt='' />
                                    <h3 class="mt-0">Blockchain</h3>
                                    <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='our-privacy-policy top bottom'>
                <div className='container'>
                    <h2 className='heading1'>Our Pricing Policy</h2>
                    <p className='prose-lg'>Based on the project and the type of service provided, we adopt one of the following pricing models:</p>
                    <div className='row'>
                        <div className='col-lg-3 col-md-6'>
                            <div className='policy-content'>
                                <p className='prose-lg'><strong>Fixed price</strong></p>
                                <p className='prose-md'>Ideal for medium-sized projects with a clearly defined scope.</p>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6'>
                            <div className='policy-content'>
                                <p className='prose-lg'><strong>Time and Material</strong></p>
                                <p className='prose-md'>Best suited for medium to large projects, as well as consulting services, that are dynamic and require flexibility.</p>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6'>
                            <div className='policy-content'>
                                <p className='prose-lg'><strong>Pricing based on consumption.</strong></p>
                                <p className='prose-md'>Typically used for managed services and help desk support (e.g., number of tickets resolved, cloud resources utilized).</p>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6'>
                            <div className='policy-content'>
                                <p className='prose-lg'><strong>Recurring monthly subscription fee</strong></p>
                                <p className='prose-md'>Ideal for support services.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="pimcore_area_quotation pimcore_area_content ">
                <div class="container">
                    <div class="qe-container " data-track-source="Quotation Editable">
                        <div class="qe-wrapper ">
                            <div class="qe-author">
                                <div class="qe-author-img">
                                    <Link to="/about#" class="js-track-click" data-track-text="Boris Shiklo">
                                        <img class="lazy entered loaded" width="300" height="300" src={require('../assets/images/ceo.webp')} alt="" data-ll-status="loaded" />
                                    </Link>
                                </div>
                                <div class="qe-author-info">
                                    <div class="qe-author-name">
                                        <Link to="/about#" class="js-track-click" data-track-text="Boris Shiklo">
                                            Harsh Sinha
                                        </Link>
                                    </div>
                                    <div class="qe-author-position">
                                        <p>CEO at Winklix</p>
                                    </div>
                                </div>
                            </div>
                            <blockquote class="qe-quote">
                                <div class="qe-quote-info">
                                    <div class="qe-quote-title d-none">
                                    </div>
                                    <div class="qe-quote-text text-indent">
                                        <p>"Reducing costs through low rates isn't effective in today's fast-paced IT landscape. While low rates may seem attractive, they often lead to longer hours spent on tasks. At Winklix, we don't cut costs by hiring underpaid employees. Instead, we focus on increasing productivity—delivering more in less time. This approach leads to lower overall costs for delivering new features, maintaining stable infrastructure, and resolving user issues."</p>
                                    </div>
                                </div>
                                <div class="qe-quote-link-wrapper">
                                </div>
                            </blockquote>
                        </div>
                    </div>
                </div>
            </div>

            <div className='productivity'>
                <div className='container'>
                    <div className='row'>
                        <p className="prose-lg">To <strong>boost productivity</strong> and <strong>reduce project costs</strong> for our clients, we allocate a portion of our revenue to:</p>
                        <div className='service-para'>
                            <ul>
                                <li>Quality management and process optimization.</li>
                                <li>Adoption of cutting-edge technologies.</li>
                                <li>Employee training and development.</li>
                            </ul>
                        </div>
                        <p className="prose-lg">Additionally, to accelerate software delivery and optimize the Total Cost of Ownership (TCO), we leverage the following <strong>technologies</strong> and <strong>methodologies:</strong></p>
                        <div className='service-para'>
                            <ul>
                                <li>Cloud-native architecture.</li>
                                <li>DevOps practices and CI/CD pipeline implementation.</li>
                                <li>Test automation.</li>
                                <li>Application Performance Management.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className='partner-support top bottom'>
                <div className='container'>
                    <div className='partner-support-user'>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <div className='partner-logo'>
                                    <img src={require('../assets/images/footer-cnt.webp')} alt='' />
                                </div>
                            </div>

                            <div className='col-lg-8'>
                                <div className='partner-heading'>
                                    <h3 className='text-white'>Looking for a Partner to Support Your Business Growth or Monetize Your Idea?</h3>
                                    <Link to="https://www.winklix.com/contact"><button>Contact</button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='contact-form-section bottom'>
                <div className='container'>
                    <div className='row contact_outlet'>
                        <div className='col-lg-3'>
                            <h3>Contact Us</h3>

                            <div className='contact-social top'>
                                <div className='call_1'>
                                    <Link to="tel:+13477462125">
                                        <img src={require('../assets/images/call-us.webp')} alt="" />
                                        &nbsp;<span>+1-(347) 746 2125</span>
                                    </Link>
                                </div>
                                <div className='call_1'>
                                    <Link to="tel:+447418343214">
                                        <img src={require('../assets/images/call-us.webp')} alt="" />
                                        &nbsp;<span>+44 74183 43214</span>
                                    </Link>
                                </div>
                                <div className='call_1'>
                                    <Link to="tel:+918882313131">
                                        <img src={require('../assets/images/call-us.webp')} alt="" />
                                        &nbsp;<span>+91 8882313131</span>
                                    </Link>
                                </div>
                                <div className='call_2'>
                                    <Link to="mailto:info@winklix.com">
                                        <img src={require('../assets/images/mail-us.webp')} alt="" />
                                        &nbsp; info@winklix.com
                                    </Link>
                                </div>
                                <div className='call_3'>
                                    <Link to="https://wa.me/13477462125" target="_blank">
                                        <img src={require('../assets/images/whtsp.webp')} alt="" />
                                        &nbsp;+1-(347) 746 2125
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-9'>
                            <div id="hubspot-form-container"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
